import Button from "../../../components/buttons/button";
import DateInput from "../../../components/inputs/dateInput";
import TextInput from "../../../components/inputs/textInput";
const EditLeave = ({ t, setOpen, formik, selected }) => {
  return (
    <section className="space-y-4">
      <div className="inputs">
        <TextInput
          formik={formik}
          name={`days[${selected.i}].name`}
          label={t("name")}
        />
      </div>

      <div className="inputs">
        <DateInput
          formik={formik}
          name={`days[${selected.i}].start`}
          label={t("startDate")}
        />
        <DateInput
          formik={formik}
          name={`days[${selected.i}].end`}
          label={t("endDate")}
        />
      </div>

      <div className="flex items-center justify-end gap-3">
        <Button
          className={"bg-primary justify-center w-[130px] text-[#1F384C] text-sm"}
          onClick={() => setOpen(false)}
        >
          {t("confirm")}
        </Button>
        <Button
          className={"border border-[#C42E27] text-[#C42E27] text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
      </div>
    </section>
  );
};

export default EditLeave;
